module.exports = __webpack_public_path__ + "img/Spokesperson.0be1bf5c.gif";